// extracted by mini-css-extract-plugin
module.exports = {"root":"m-parent_m-child__3uRg9Bsq"};